import { ButtonProps, styled } from "@mui/material";
import IotVisionButton from "components/common/IotVisionButton";

const SecondaryButton = styled((SecondaryButtonProps: ButtonProps) => (
    <IotVisionButton
        {...SecondaryButtonProps}
        sx={{
            height: "25px",
            width: "120px",
            fontSize: "12px",
            fontWeight: 400,
            backgroundColor: "#F5F5FB",
            borderColor: "#F5F5FB",
            color: "#001B4F",
            "&:hover": {
                background: "#F5F5FB",
            },
        }}
    />
))(() => ({}));

export default SecondaryButton;
